import type { ILocatedElement } from 'clickim/src/background/codeSnippets/getLocatedElement';

declare function getLocatedElement(locatedElement: ILocatedElement | string): Element | null;

export type DispatchFocusFn = typeof dispatchFocus;
export function dispatchFocus(targetElement: false | ILocatedElement | string | undefined, oldActiveElement: Element | null) {
    function createFocusEvent(eventName: string) {
        const event = document.createEvent('HTMLEvents');
        // TODO we want to use new Event, but mootools (used by zuora which is used by jfrog) overrides window.Event and throws an error
        event.initEvent(eventName, true, false);
        return event;
    }

    function findEffectiveActiveElement() {
        let activeElement = document.activeElement!;
        while (activeElement.shadowRoot?.activeElement) {
            activeElement = activeElement.shadowRoot.activeElement;
        }
        return activeElement;
    }

    function setFocus(element: Element, _oldActiveElement: Element | null) {
        if (_oldActiveElement) {
            _oldActiveElement.dispatchEvent(createFocusEvent('focusout'));
            _oldActiveElement.dispatchEvent(createFocusEvent('blur'));
        }
        element.dispatchEvent(createFocusEvent('focusin'));
        element.dispatchEvent(createFocusEvent('focus'));
        if (typeof (element as HTMLElement).focus === 'function') {
            (element as HTMLElement).focus();
        }
        const currentActiveElement = findEffectiveActiveElement();
        if (_oldActiveElement && currentActiveElement === _oldActiveElement && typeof (_oldActiveElement as HTMLElement).blur === 'function') {
            (_oldActiveElement as HTMLElement).blur();
        }
    }

    if (targetElement) {
        const elementToFocus = getLocatedElement(targetElement);
        if (elementToFocus && (elementToFocus !== oldActiveElement)) {
            try {
                setFocus(elementToFocus, oldActiveElement);
            } catch (e) {
                // ignore
            }
        }
    } else if (oldActiveElement && typeof (oldActiveElement as HTMLElement).blur === 'function') {
        (oldActiveElement as HTMLElement).blur();
    }
}
